import { ApiClient } from "./ApiClient";

export interface CombinedPressReleaseItem {
    year: number;
    name: string;
    typeText: string;
    url: string;
    publishDateFormatted: string;
    publishDateDisplay: string;
}

export interface CombinedPressReleasePageData {
    combinedPressReleases: CombinedPressReleaseItem[];
    totalPages: number;
    totalPressReleases: number;
}

export interface CombinedPressReleaseQueryParams {
    [key: string]: string | number | undefined;
    page?: number;
    perPage?: number;
    year?: string;
    type?: string;
    pageID?: string;
    lang?: string;
}

export class CombinedPressReleaseApi {
    private apiClient = new ApiClient("/api/combinedpressrelease");

    public getPageData(params: CombinedPressReleaseQueryParams) {
        return this.apiClient.get<CombinedPressReleasePageData>("pageData", params);
    }
}

export const combinedPressReleaseApi = new CombinedPressReleaseApi();
